/* Vanshitaaz — Watch 'n' Shop lazy video.
   Each tile video has <source data-src>. We only load + play a video when
   its tile scrolls into view, and pause it when it leaves — so a row of
   6–12 tiles stays light (only the visible clips ever download). */
(function () {
  'use strict';

  function loadVideo(video) {
    if (video.dataset.wnsLoaded) return;
    video.dataset.wnsLoaded = '1';
    video.querySelectorAll('source[data-src]').forEach(function (s) {
      s.src = s.getAttribute('data-src');
    });
    video.load();
  }

  function init() {
    var videos = document.querySelectorAll('[data-wns-video]');
    if (!videos.length) return;

    if (!('IntersectionObserver' in window)) {
      // Fallback: just load + play everything.
      videos.forEach(function (v) { loadVideo(v); v.play().catch(function () {}); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          loadVideo(v);
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { rootMargin: '200px 0px', threshold: 0.25 });

    videos.forEach(function (v) { io.observe(v); });
  }

  // ---- pagination dots: active-on-scroll + click-to-scroll ----
  function initDots() {
    document.querySelectorAll('[data-wns-dots]').forEach(function (dots) {
      var section = dots.closest('.watch-n-shop');
      var row = section && section.querySelector('.wns-row');
      if (!row) return;
      var tiles = row.querySelectorAll('.wns-tile');
      var buttons = dots.querySelectorAll('.wns-dot');
      if (!tiles.length || !buttons.length) return;

      function activeIndex() {
        var mid = row.scrollLeft + row.clientWidth / 2;
        var best = 0, bestDist = Infinity;
        tiles.forEach(function (t, i) {
          var c = t.offsetLeft + t.offsetWidth / 2;
          var d = Math.abs(c - mid);
          if (d < bestDist) { bestDist = d; best = i; }
        });
        return best;
      }
      function sync() {
        var i = activeIndex();
        buttons.forEach(function (b, bi) { b.classList.toggle('is-active', bi === i); });
      }
      var raf;
      row.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () { raf = null; sync(); });
      }, { passive: true });

      buttons.forEach(function (b) {
        b.addEventListener('click', function () {
          var t = tiles[parseInt(b.getAttribute('data-i'), 10)];
          if (t) row.scrollTo({ left: t.offsetLeft - row.offsetLeft, behavior: 'smooth' });
        });
      });
      sync();
    });
  }

  function boot() { init(); initDots(); }

  if (document.readyState !== 'loading') { boot(); }
  else { document.addEventListener('DOMContentLoaded', boot); }
})();
